import { createReducer } from "@reduxjs/toolkit";
import License from "spectral-core/models/License";
import { setLicensesAction, setLicensesLogoutAction } from "./licenses.actions";

export interface LicensesState {
  licenses: License[] | undefined;
}

const initialState: LicensesState = {
  licenses: undefined
}

const licenseReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setLicensesAction, (state, action) => {
      state.licenses = action.payload;
    })
    .addCase(setLicensesLogoutAction, (state, action) => {
      state.licenses = initialState.licenses;
    })
});

export default licenseReducer;